<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'PointsProduct',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'pointsProduct:add',
        update: 'pointsProduct:update',
        delete: 'pointsProduct:delete',
        deleteBatch: 'pointsProduct:deleteBatch'
      },
      url: {
        get: '/pointsProduct/listByCondition',
        add: '/pointsProduct/add',
        update: '/pointsProduct/update',
        delete: '/pointsProduct/delete',
        delete_batch: '/pointsProduct/deleteBatch',
        status: '/pointsProduct/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      },
        {
          field: 'name',  // 字段名
          label: '名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'points',  // 字段名
          label: '积分',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'giftPoints',  // 字段名
          label: '赠送积分',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'price',  // 字段名
          label: '价格',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'allowFirstRecharge',  // 字段名
          label: '是否首充',  // 字段显示名称
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '关闭',
              type: 'info'
            }, {
              key: 1,
              value: '开启',
              type: 'success'
            }]
          },

        }, {
          field: 'maxSelection',  // 字段名
          label: '最多人选',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '关闭',
              type: 'info'
            }, {
              key: 1,
              value: '开启',
              type: 'success'
            }]
          },
        }, {
          field: 'systemType',  // 字段名
          label: '系统',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 1,
              value: '安卓',
              type: 'success'
            }, {
              key: 2,
              value: '苹果',
              type: 'success'
            }]
          },
        }, {
          field: 'googleProductId',  // 字段名
          label: '谷歌商品ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'iosProductId',  // 字段名
          label: 'ios商品ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          status: true,
        }, {
          field: 'sortNumber',  // 字段名
          label: '排序',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          }, {
            field: 'agentId',
            label: '代理',
            type: 'select',
            selectUrl: '/agent/getAll',
            selectData: [],
            placeholder: '请选择',
            rules: [{
              message: '请选择代理', trigger: 'blur', required: true
            }],
            add: true,
            update: true,
          },
          {
            field: 'name',  // 字段名
            label: '名称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入名称',
            rules: [
              {required: true, message: '名称不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'points',  // 字段名
            label: '积分数量',  // 字段显示名称
            type: 'input',
            placeholder: '请输入积分数量',
            rules: [
              {required: true, message: '积分数量不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'giftPoints',  // 字段名
            label: '赠送积分',  // 字段显示名称
            type: 'input',
            placeholder: '请输入赠送积分',
            rules: [
              {required: true, message: '赠送积分不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'price',  // 字段名
            label: '价格',  // 字段显示名称
            type: 'input',
            placeholder: '请输入价格',
            rules: [
              {required: true, message: '价格不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'allowFirstRecharge',  // 字段名
            label: '是否首充',  // 字段显示名称
            type: 'select',
            placeholder: '请选择是否开启首充',
            rules: [
              {required: true, message: '状态不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 1,
              name: '开启'
            }, {
              id: 0,
              name: '关闭'
            }],
            add: true,
            update: true,
          }, {
            field: 'maxSelection',  // 字段名
            label: '最多人选',  // 字段显示名称
            type: 'select',
            placeholder: '请选择最多人选提示',
            rules: [
              {required: true, message: '提示不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 1,
              name: '开启提示'
            }, {
              id: 0,
              name: '关闭提示'
            }],
            add: true,
            update: true,
          }, {
            field: 'systemType',  // 字段名
            label: '系统',  // 字段显示名称
            type: 'select',
            placeholder: '请选择系统',
            rules: [
              {required: true, message: '系统不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 1,
              name: '安卓'
            }, {
              id: 2,
              name: '苹果'
            }],
            add: true,
            update: true,
          }, {
            field: 'googleProductId',  // 字段名
            label: '谷歌商品ID',  // 字段显示名称
            type: 'input',
            placeholder: '请输入googleProductId',
            rules: [
              {required: false, message: 'googleProductId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'iosProductId',  // 字段名
            label: 'IOS商品ID',  // 字段显示名称
            type: 'input',
            placeholder: '请输入iosProductId',
            rules: [
              {required: false, message: 'iosProductId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: '状态',  // 字段显示名称
            type: 'select',
            placeholder: '请输入status',
            rules: [
              {required: true, message: '系统不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 1,
              name: '开启'
            }, {
              id: 0,
              name: '关闭'
            }],
            add: true,
            update: true,
          }, {
            field: 'sortNumber',  // 字段名
            label: '排序',  // 字段显示名称
            type: 'input',
            placeholder: '请输入sortNumber',
            rules: [
              {required: true, message: 'sortNumber不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
